export default __webpack_public_path__ + "static/media/inactiveListView.733b8233.svg";